import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import {
  getVariantsForMode,
  MOBILE_THEME_VARIANT_META,
} from '../theme/mobileTheme';
import { useMobileThemeContext } from '../context/MobileThemeProvider';

export default function MobileThemeVariantPicker() {
  const { mode, variant, setVariant } = useMobileThemeContext();

  const options = getVariantsForMode(mode);

  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Teemavariantit
      </Typography>
      <Stack direction="row" flexWrap="wrap" useFlexGap spacing={1}>
        {options.map((id) => {
          const meta = MOBILE_THEME_VARIANT_META[id];
          return (
            <Chip
              key={id}
              label={`${id} ${meta.label}`}
              size="small"
              color={variant === id ? 'primary' : 'default'}
              variant={variant === id ? 'filled' : 'outlined'}
              onClick={() => setVariant(id)}
              aria-pressed={variant === id}
              aria-label={`${id} ${meta.label}: ${meta.hint}`}
            />
          );
        })}
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5, fontSize: '0.75rem' }}>
        Voit myös avata suoraan esim.{' '}
        <Box component="span" sx={{ fontFamily: 'monospace' }}>
          {mode === 'dark' ? '/m?theme=D3' : '/m?theme=L2'}
        </Box>
      </Typography>
    </Box>
  );
}
